import "./App.css";
import DivorceAssess from "./Pages/DivorceAssess";
import firebase from "firebase";
import "firebase/functions";

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Welcome from "./Pages/Welcome";

import { AppDataProvider } from "./Store/store";
import ThankYou from "./Pages/ThankYou";
import TagManager from "react-gtm-module";

// Initialize Cloud Functions through Firebase

const firebaseConfig = {
  apiKey: "AIzaSyAfm7PgNtW6ZvGFmqOI99bbYzGrTv86IhA",
  authDomain: "family-law-master.firebaseapp.com",
  projectId: "family-law-master",
  storageBucket: "family-law-master.appspot.com",
  messagingSenderId: "184559929009",
  appId: "1:184559929009:web:1843655608fa4f19188490",
  measurementId: "G-YXDZXGL3P3",
};

firebase.initializeApp(firebaseConfig);

// const functions = firebase.functions();

const tagManagerArgs = {
  gtmId: "G-RZW1QJGCNK",
};
TagManager.initialize(tagManagerArgs);

function App() {
  return (
    <AppDataProvider>
      <Router>
        <Switch>
          <Route exact path="/">
            <Welcome />
          </Route>
          <Route path="/divorce-assessment">
            <DivorceAssess />
          </Route>
          <Route path="/thank-you">
            <ThankYou />
          </Route>
        </Switch>
      </Router>
    </AppDataProvider>
  );
}

export default App;
